import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLinkClick = () => {
    setMenuOpen(false); // close menu on navigation
  };

  return (
    <header className="header">
      <div className="container">
        <nav className="navbar">
          {/* <Link to="/" className="logo" onClick={handleLinkClick}>
            <span className="logo-icon">🩺</span>
            <span className="logo-text">Gopalan Aarogyam</span>
          </Link> */}
          <Link to="/" className="logo" onClick={handleLinkClick}>
            <span className="logo-icon">
              <img src="/logo192.png" alt="Gopalan Aarogyam logo" />
            </span>
            <span className="logo-text">Gopalan Aarogyam</span>
          </Link>



          {/* Hamburger */}
          <button
            className={`hamburger ${menuOpen ? 'open' : ''}`}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle navigation"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

          <ul className={`nav-links ${menuOpen ? 'show' : ''}`}>
            <li>
              <Link
                to="/"
                className={location.pathname === '/' ? 'active' : ''}
                onClick={handleLinkClick}
              >
                Home
              </Link>
            </li>
            <li>
              <Link
                to="/about"
                className={location.pathname === '/about' ? 'active' : ''}
                onClick={handleLinkClick}
              >
                About Us
              </Link>
            </li>
            {/* <li>
              <Link
                to="/services"
                className={location.pathname === '/services' ? 'active' : ''}
                onClick={handleLinkClick}
              >
                Our Services
              </Link>
            </li> */}
            <li>
              <Link
                to="/lab-test"
                className={location.pathname === '/lab-test' ? 'active' : ''}
                onClick={handleLinkClick}
              >
                Lab Test
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;